import { FormDescriptor } from '../redux';

/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
export const AUTHORIZATION_HEADER = "Authorization";
export const CONTENT_TYPE_HEADER = "Content-Type";
export const LAST_MODIFIED = "Last-Modified";
export const CURRENT_USER = "currentUser";

export interface PagedResponse<T> {
  total: number;
  offset: number;
  max: number;
  results: T[];
  prev: string | null;
  next: string | null;
  self: string;
}

/**
 * Latest minor version of each major version of each form type. Only these evaluations should be creatable.
 * 
 * @example
 * ```typescript
 * {
 *  'farm_ac_v4': {
 *     3: // def for latest v3
 *     2: ...
 *     1: ...
 *     0: ...
 *   },
 *   'farm_es_v2': { ... }
 * }
 * ```
 */
export interface LatestVersionsByFormType {
  /**
   * Keyed by form type (farm_ac_v4, farm_es_v2, etc)
   */
  [key: string]: {
    /**
     * Keyed by latest major version
     */
    [key: string]: FormDescriptor
  }
}
